import { z } from "zod";

/**
 * Skema untuk keseluruhan respons dari endpoint DELETE /company/{id}.
 * Endpoint ini biasanya hanya mengkonfirmasi bahwa operasi penghapusan berhasil
 * dan tidak mengembalikan data dari entitas yang dihapus.
 */
export const DeleteCompanyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    // Karena entitas telah dihapus, respons tidak mengandung data,
    // sehingga kita secara eksplisit memvalidasinya sebagai 'null'.
    data: z.null(),
});

// Mengekspor tipe data TypeScript yang di-infer dari skema Zod.
export type DeleteCompanyResponse = z.infer<typeof DeleteCompanyResponseSchema>;